/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Header } from "@/components/Header";
import { useTranslation } from "react-i18next";
import { CssHome, CardCss, ProxximaCss, SuvinilCss, SuperBonderCss, KevlarCss } from "./css";
import ReactHtmlParser from "html-react-parser";

//CssHome
import setaCase from "@/assets/cases/realTime/setaAzul.png";

//CARDCSS
import saoPauloHouse from "@/assets/cases/realTime/saoPauloHouse.png";
import setaVermelhaGrande from "@/assets/cases/realTime/setaVermelhaGrande.png";
import triangulo from "@/assets/cases/realTime/triangulo.png";

import insta1 from "@/assets/cases/realTime/insta1.png";
import insta2 from "@/assets/cases/realTime/insta2.png";
import insta3 from "@/assets/cases/realTime/insta3.png";
import insta4 from "@/assets/cases/realTime/insta4.png";

import moldura from "@/assets/cases/realTime/moldura.png";
import celular400 from "@/assets/cases/realTime/celular400.png";

import bgVideo from "@/assets/cases/realTime/bgVideo.png";
import saoPauloHouseBranco from "@/assets/cases/realTime/saoPauloHouseBranco.png";
import { Footer } from "@/components/Footer";

//PROXIMMA
import logoProxxima from "@/assets/cases/realTime/logo-proxxima.png";
import cardProxxima from "@/assets/cases/realTime/card-proxxima.png";
import celularProxxima from "@/assets/cases/realTime/celular-proxxima.png";
import setaProxxima from "@/assets/cases/realTime/setaVermelhaGrande.png";
import trianguloProxxima from "@/assets/cases/realTime/triangulo.png";

//SUVINIL
import logoSicredi from "@/assets/cases/realTime/logo-sicredi.png";
import fotoCardSuvinil from "@/assets/cases/realTime/foto-card-suvinil.jpg";
import zAzul from "@/assets/cases/realTime/z-azul.png";
import celularSuvinil from "@/assets/cases/realTime/celular-suvinil.png";
import dentesAzul from "@/assets/cases/realTime/dentes-azul.png";

// SUPER BONDER
import logoSuperBonder from "@/assets/cases/realTime/logo-super-bonder.png";
import celularSuperBonder from "@/assets/cases/realTime/celular-super-bonder.png";
import quadroSuperBonder from "@/assets/cases/realTime/quadro-super-bonder.png";

// KEVLAR
import logoKevlar from "@/assets/cases/realTime/logo-kevlar.png";
import celularKevlar from "@/assets/cases/realTime/celular-kevlar.png";
import quadroKevlar from "@/assets/cases/realTime/quadro-kevlar.png";

const CasesRealTime = () => {
 	const { t } = useTranslation();

   	const sectionCardsRef = useRef(null);
 	const [cardsVisible, setCardsVisible] = useState(false);

	const sectionProxximaRef = useRef(null);
	const [proxximaVisible, setProxximaVisible] = useState(false);

	const sectionSuvinilRef = useRef(null);
	const [suvinilVisible, setSuvinilVisible] = useState(false);

	const sectionSuperBonderRef = useRef(null);
	const [superBonderVisible, setSuperBonderVisible] = useState(false);

	const sectionKevlarRef = useRef(null);
	const [kevlarVisible, setKevlarVisible] = useState(false);

	useEffect(() => {
		const section = sectionCardsRef.current;

		if (!section) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
				setCardsVisible(true);
				observer.unobserve(entry.target);
				}
			},
			{
				threshold: 0.10,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return () => {
		observer.disconnect();
		};
	}, []);

	useEffect(() => {
		const section = sectionProxximaRef.current;

		if (!section) return;

		const observer = new IntersectionObserver(
			([entry]) => {
			if (entry.isIntersecting) {
				setProxximaVisible(true);
				observer.unobserve(entry.target);
			}
			},
			{
			threshold: 0.08,
			rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return () => {
			observer.disconnect();
		};
	}, []);

	useEffect(() => {
		const section = sectionSuvinilRef.current;

		if (!section) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setSuvinilVisible(true);
					observer.unobserve(entry.target);
				}
			},
			{
				threshold: 0.08,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return () => {
			observer.disconnect();
		};
	}, []);

	useEffect(() => {
		const section = sectionSuperBonderRef.current;

		if (!section) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setSuperBonderVisible(true);
					observer.unobserve(entry.target);
				}
			},
			{
				threshold: 0.08,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return () => {
			observer.disconnect();
		};
	}, []);

	useEffect(() => {
		const section = sectionKevlarRef.current;

		if (!section) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setKevlarVisible(true);
					observer.unobserve(entry.target);
				}
			},
			{
				threshold: 0.08,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return () => {
			observer.disconnect();
		};
	}, []);
		
  return (
    <>
		<Helmet>
			<title>Zest Ag | Cases | Real Time</title>

			<link rel="shortcut icon" href="https://zest.ag/favicon.png?v=3" />
			<link rel="icon" type="image/png" href="https://zest.ag/favicon.png?v=3" />
			<link rel="apple-touch-icon" href="https://zest.ag/favicon.png?v=3" />

			<meta name="description" content="Zest AG - The full responsa agency" />
			<meta
			name="keywords"
			content="Zest One, Agência de marketing, negócios e interesses do cliente, inbound"
			/>

			<meta property="og:url" content="https://zest.ag/CasesRealTime" />
			<meta property="og:type" content="website" />
			<meta property="og:title" content="Zest Ag | Cases | Real Time" />
			<meta property="og:description" content="Zest Ag - The full responsa agency" />
			<meta property="og:image" content="https://zest.ag/avatar.jpg" />
		</Helmet>

		<Header />

		<div className="clear"/>

		<CssHome>
			<section className="caseHero">
				<div className="caseContainer">					
					<div className="caseIntro">
						<h1>
							<span className="titleLine titleRealTime">
							{ReactHtmlParser(t("casesRealtime.titulo").split("<br />")[0])}
							</span>

							<span className="titleLine titleProducao">
							{ReactHtmlParser(t("casesRealtime.titulo").split("<br />")[1])}
							</span>
						</h1>

						<p>{t("casesRealtime.descricao")}</p>
					</div>
				</div>
			</section>
		</CssHome>

		<CardCss ref={sectionCardsRef} className={cardsVisible ? "isVisible" : ""}>
			<section className="cardsSection">
			<div className="cardsContainer">

				<div className="cardsHeader">
				<img
					src={saoPauloHouse}
					alt="São Paulo House"
					className="saoPauloLogo scrollItem logoAnim"
				/>

				<p className="cardsText scrollItem textAnim">
					{t("casesRealtime.descricaoSaoPauloHouse")}
				</p>

				<img
					src={setaVermelhaGrande}
					alt=""
					className="bigArrow scrollItem arrowAnim"
				/>
				</div>

				<div className="instaRow">
				<img src={insta1} alt="" className="instaCard instaCard1 scrollItem" />
				<img src={insta2} alt="" className="instaCard instaCard2 scrollItem" />
				<img src={insta3} alt="" className="instaCard instaCard3 scrollItem" />
				<img src={insta4} alt="" className="instaCard instaCard4 scrollItem" />
				</div>

				<div className="resultsArea">
				<img
					src={triangulo}
					alt=""
					className="triangle triangleLeft scrollItem triangleLeftAnim"
				/>

				<div className="mediaWrap">
					<img
					src={moldura}
					alt=""
					className="moldura scrollItem molduraAnim"
					/>

					<img
					src={celular400}
					alt=""
					className="celular scrollItem celularAnim"
					/>
				</div>

				<div className="numbersWrap">
					<div className="numberBox numberBoxRed scrollItem number400Anim">
						<strong>+200</strong>
						<span>{t("casesRealtime.400mil")}</span>
					</div>

					<div className="numberBox numberBoxOutline scrollItem number20Anim">
						<strong>+ 2000</strong>
						<span>{t("casesRealtime.200mil")}</span>
					</div>

					<div className="numberBox numberBoxOutline numberBoxSpeakers scrollItem numberSpeakersAnim">
						<strong>+140</strong>
						<span>{t("casesRealtime.140speakers")}</span>
					</div>

					<img
					src={triangulo}
					alt=""
					className="triangle triangleRight scrollItem triangleRightAnim"
					/>
				</div>
				</div>

				<div className="afterMovieArea">
					<img src={bgVideo} alt="" className="afterMovieBg" />

					<div className="afterMovieContent">
						<div className="afterMovieTextBox scrollItem afterMovieInfoAnim">
							<img
								src={saoPauloHouseBranco}
								alt="São Paulo House"
								className="afterMovieLogo"
							/>

							<h2>AFTERMOVIE</h2>

							<p>
								{t("casesRealtime.afterMovieDescricao")}
							</p>
						</div>

						<div className="afterMovieVideoBox scrollItem afterMovieVideoAnim">
							<iframe
								src="https://player.vimeo.com/video/1190258527?autoplay=1&muted=1&loop=1&autopause=0"
								title="Vídeo ZEST"
								frameBorder="0"
								allow="autoplay; fullscreen; picture-in-picture"
								allowFullScreen
							/>
						</div>
					</div>
				</div>


			</div>
			</section>
		</CardCss>

		<ProxximaCss ref={sectionProxximaRef} className={proxximaVisible ? "isVisible" : ""}>
			<section className="proxximaSection">
				<div className="proxximaContainer">
					<div className="proxximaHeader">
						<img
						src={logoProxxima}
						alt="Proxxima"
						className="proxximaLogo proxximaScroll proxximaLogoAnim"
						/>

						<p className="proxximaIntroText proxximaScroll proxximaIntroTextAnim">
						{t("casesRealtime.proxximaDescricao")}
						</p>
					</div>

					<div className="proxximaNumbers">
						<div className="proxximaNumber proxximaNumberSmall proxximaScroll proxximaNumberSmallAnim">
							<img src={trianguloProxxima} alt="" className="proxximaNumberTriangle triangleSmall" />
							<strong>+200K</strong>
							<span>{t("casesRealtime.proxximaIndicador1")}</span>
						</div>

						<div className="proxximaNumber proxximaNumberBig proxximaScroll proxximaNumberBigAnim">
							<img src={trianguloProxxima} alt="" className="proxximaNumberTriangle2 triangleBig" />
							<strong>900K</strong>
							<span>{t("casesRealtime.proxximaIndicador2")}</span>
						</div>
					</div>

					<img
						src={celularProxxima}
						alt=""
						className="proxximaPhone proxximaScroll proxximaPhoneAnim"
					/>

					<img
						src={cardProxxima}
						alt=""
						className="proxximaCard proxximaScroll proxximaCardAnim"
					/>

					<div className="proxximaBottom proxximaScroll proxximaBottomAnim">
						<img src={setaProxxima} alt="" />
						<p>{t("casesRealtime.proxximaTextoFinal")}</p>
					</div>
				</div>
			</section>
		</ProxximaCss>

		<SuvinilCss ref={sectionSuvinilRef} className={suvinilVisible ? "isVisible" : ""}>
			<section className="suvinilSection">
				<div className="suvinilContainer">

					<div className="suvinilHeader">
						<img
							src={logoSicredi}
							alt="Suvinil Revela"
							className="suvinilLogo suvinilScroll suvinilLogoAnim"
						/>

						<p className="suvinilIntroText suvinilScroll suvinilIntroTextAnim">
							{t("casesRealtime.suvinilDescricao")}
						</p>
					</div>

					<img
						src={fotoCardSuvinil}
						alt=""
						className="suvinilPhotoCard suvinilScroll suvinilPhotoCardAnim"
					/>

					<img
						src={zAzul}
						alt=""
						className="suvinilZ suvinilScroll suvinilZAnim"
					/>

					<img
						src={celularSuvinil}
						alt=""
						className="suvinilPhone suvinilScroll suvinilPhoneAnim"
					/>

					<div className="suvinilNumber suvinilNumber900 suvinilScroll suvinilNumber900Anim">
						<img src={trianguloProxxima} alt="" className="Triangle900 triangleSmallRight" />
						<strong>{t("casesRealtime.30filmes")}</strong>
						<span>{t("casesRealtime.suvinilIndicador900")}</span>
					</div>

					<div className="suvinilNumber suvinilNumber200 suvinilScroll suvinilNumber200Anim">
						<img src={trianguloProxxima} alt="" className="Triangle200 triangleSmall" />
						<strong>{t("casesRealtime.suvinilIndicador200")}</strong>
						{/* <span>{t("casesRealtime.suvinilIndicador200")}</span> */}
					</div>

					<p className="suvinilBottomText suvinilScroll suvinilBottomTextAnim">
						{ReactHtmlParser(t("casesRealtime.suvinilTextoFinal"))}
					</p>

					<img
						src={dentesAzul}
						alt=""
						className="suvinilDentes suvinilScroll suvinilDentesAnim"
					/>

				</div>
			</section>
		</SuvinilCss>

		<SuperBonderCss
			ref={sectionSuperBonderRef}
			className={superBonderVisible ? "isVisible" : ""}
		>
			<section className="superBonderSection">
				<div className="superBonderContainer">

					<div className="superBonderHeader">
						<img
							src={logoSuperBonder}
							alt="Loctite Super Bonder"
							className="superBonderLogo superBonderScroll superBonderLogoAnim"
						/>

						<p className="superBonderIntroText superBonderScroll superBonderIntroTextAnim">
							{t("casesRealtime.superBonderDescricao")}
						</p>
					</div>

					<img
						src={setaVermelhaGrande}
						alt=""
						className="superBonderArrow superBonderScroll superBonderArrowAnim"
					/>

					<div className="superBonderPhoneWrap superBonderScroll superBonderPhoneAnim">
						<img
							src={celularSuperBonder}
							alt=""
							className="superBonderPhone"
						/>
					</div>

					<div className="superBonderResultText superBonderScroll superBonderTextResultAnim">
						{/* <h2>{t("casesRealtime.superBonderTituloIndicador")}</h2> */}
						<p>{t("casesRealtime.superBonderTextoIndicador")}</p> 
					</div>

					<div className="superBonderNumber superBonderScroll superBonderNumberAnim">
						<img src={triangulo} alt="" className="superBonderTriangle" />
						<strong>{t("casesRealtime.superBonderIndicador")}</strong>
						<span>{t("casesRealtime.superBonderIndicador200")}</span>
					</div>

					<img
						src={quadroSuperBonder}
						alt=""
						className="superBonderPhotos superBonderScroll superBonderPhotosAnim"
					/>

				</div>
			</section>
		</SuperBonderCss>

		<KevlarCss
			ref={sectionKevlarRef}
			className={kevlarVisible ? "isVisible" : ""}
		>
			<section className="kevlarSection">
				<div className="kevlarContainer">

					<div className="kevlarHeader">
						<img
							src={logoKevlar}
							alt="Kevlar"
							className="kevlarLogo kevlarScroll kevlarLogoAnim"
						/>

						<p className="kevlarIntroText kevlarScroll kevlarIntroTextAnim">
							{t("casesRealtime.kevlarDescricao")}
						</p>
					</div>

					<img
						src={zAzul}
						alt=""
						className="kevlarZ kevlarScroll kevlarZAnim"
					/>

					<div className="kevlarPhoneWrap kevlarScroll kevlarPhoneAnim">
						<img
							src={celularKevlar}
							alt=""
							className="kevlarPhone"
						/>
					</div>

					<div className="kevlarNumber kevlarScroll kevlarNumberAnim">
						<strong>+ 30%</strong>
						<span>{t("casesRealtime.kevlarIndicador200")}</span>
					</div>

					<p className="kevlarBottomText kevlarScroll kevlarBottomTextAnim">
						{ReactHtmlParser(t("casesRealtime.kevlarTextoFinal"))}
					</p>

					<img
						src={quadroKevlar}
						alt=""
						className="kevlarPhotos kevlarScroll kevlarPhotosAnim"
					/>

				</div>
			</section>

			<div className="caseTop">
				<a href="/CasesTransmissaoAoVivo" className="caseNav caseNavHome">
					<img src={setaCase} alt="" />
					<span>{t("botoes.voltar")}</span>
				</a>

				<a href="/CasesConteudoSocial" className="caseNav caseNavNext">
					<span>{t("casesRealtime.proximoCase")}</span>
					<img src={setaCase} alt="" />
				</a>
			</div>

		</KevlarCss>


		<div className="clear"/>
		  <Footer />  
	  
    </>
  );
};

export default CasesRealTime;
